import { Button } from "@/components/ui/button";
import { Sparkles, TrendingUp } from "lucide-react";
import heroBg from "@/assets/hero-bg.jpg";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroBg} 
          alt="Hero background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-hero opacity-90"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl animate-slide-up">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-primary/20 backdrop-blur-sm border border-primary/30 rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-accent" />
            <span className="text-sm font-medium text-foreground">Bônus de 100% até R$ 500</span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 leading-tight">
            Apostas que
            <span className="block bg-gradient-accent bg-clip-text text-transparent">
              Fazem a Diferença
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl">
            As melhores odds do mercado, pagamento instantâneo e centenas de opções de apostas em esportes, cassino e jogos ao vivo.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="bg-gradient-primary hover:shadow-glow transition-all duration-300 text-lg px-8 py-6"
              asChild
            >
              <Link to="/register">Começar Agora</Link>
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-2 border-primary/50 hover:bg-primary/10 text-lg px-8 py-6"
              asChild
            >
              <Link to="/live-casino">
                <TrendingUp className="w-5 h-5 mr-2" />
                Ver Jogos ao Vivo
              </Link>
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-border/30">
            <div>
              <div className="text-2xl md:text-3xl font-bold text-foreground">500K+</div>
              <div className="text-sm text-muted-foreground">Usuários Ativos</div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-bold text-foreground">10k+</div>
              <div className="text-sm text-muted-foreground">Jogos Disponíveis</div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-bold text-accent">94.5%</div>
              <div className="text-sm text-muted-foreground">Taxa de Pagamento</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-glow-pulse"></div>
      <div className="absolute bottom-20 left-10 w-40 h-40 bg-accent/20 rounded-full blur-3xl animate-glow-pulse"></div>
    </section>
  );
};

export default Hero;